import {
  GoogleTagEventKey,
  GoogleTagEventKeysPort
} from '../application/ports/GoogleTagEventKeysPort';

export class GoogleTagEventKeys implements GoogleTagEventKeysPort {
  getDisplayOfferEventKey(): GoogleTagEventKey {
    return 'qlrhCIaX7ewBENOo64gD';
  }

  getEnterOnboardingEventKey(): GoogleTagEventKey {
    return 'xCB5COuIlO0BENOo64gD';
  }

  getSubmitOfferEventKey(): GoogleTagEventKey {
    return 'p2GDCMniyuwBENOo64gD';
  }

  getSubmitOrderEventKey(): GoogleTagEventKey {
    return 'G2QBCJ_oyuwBENOo64gD';
  }
}
